















































import {Component, Vue, Watch} from 'vue-property-decorator';
import {gsap} from '@/utils/gsap';

import {IArticleCategoryCard} from '@/components/types';

import {AccordionGroup} from '@/components/accordion';
import ContactUs from '@/components/ContactUs.vue';

@Component({
	components: {
		'v-accordion-group': AccordionGroup,
		'v-contact-us': ContactUs
	}
})
export default class HelpDetail extends Vue {
	data: IArticleCategoryCard[] = [];
	toggleFirst: boolean = false;
	$refs: {
		accordion: AccordionGroup & any
	};

	get activeCategory(): string | undefined {
		return this.$route.params.slug;
	}

	get activeSection(): number | undefined {
		return this.$route.query.section ? parseInt(this.$route.query.section as any) : undefined;
	}

	get activeCategoryData(): IArticleCategoryCard | undefined {
		return this.data.find((item: IArticleCategoryCard) => item.slug === this.activeCategory);
	}

	@Watch('$route', {deep: true})
	async onCategoryChanged(newValue: any): Promise<void> {
		if (newValue.query.section) {
			await this.$store.dispatch('updateHelpSection', newValue.query.section);
			await this.scrollToSection(parseInt(newValue.query.section));
		} else {
			await this.$store.dispatch('updateHelpSection', 0);
			await this.scrollToSection(0);
		}
	}

	async mounted(): Promise<void> {
		if (typeof window === 'undefined') {
			return;
		}
		if (!this.activeCategory) {
			await this.$router.push({name: `help-${this.$i18n.locale}`});
			return;
		}

		if (this.activeSection) {
			await this.$store.dispatch('updateHelpSection', this.activeSection);
		} else {
			await this.$store.dispatch('updateHelpSection', 0);
		}

		this.data = this.$t('help.categories') as any;

		this.$nextTick(() => {
			this.scrollToSection(this.activeSection);
		});
	}

	scrollToSection(section: number | undefined): void {
		if (!section) {
			return;
		}

		gsap.to(window, 1, {delay: 0.5, autoKill: false, scrollTo: `#section-${section}`});
	}
}
